import AdminAPI from 'config/api/AdminAPI';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

// Sidebar badges: how many records each list got since the user last opened it
export type BadgeModule = 'orders' | 'transfer_requests' | 'return_requests' | 'transactions';

export const getModuleBadgeCounts = async () => {
  const response = await manageAPICall(
    AdminAPI.moduleBadgeCounts.url,
    AdminAPI.moduleBadgeCounts.method,
    {}
  );
  return response;
};

// The user opened that list - its badge starts again from now. Answers with fresh counts.
export const markModuleViewed = async (module: BadgeModule) => {
  const response = await manageAPICall(
    AdminAPI.markModuleViewed.url,
    AdminAPI.markModuleViewed.method,
    { module }
  );
  return response;
};
